import { useBreakpointValue } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

import { LOADING_OFFERS_TOTAL_ROWS } from '../../../../utils/constants';
import { Mobile } from '../Item/mobile';
import { Tablet } from '../Item/tablet';
import { Separator } from '../Separator';

import { Desktop } from './desktop';

interface LoadingProps {}

export const LoadingRow = () => {
  const layout = useBreakpointValue({
    base: <Mobile isLoading />,
    sm: <Tablet isLoading />,
    lg: <Desktop />,
  });

  return layout;
};

export const Loading: React.FC<LoadingProps> = () => {
  const data = React.useMemo(
    () => Array.from({ length: LOADING_OFFERS_TOTAL_ROWS }, (_, i) => i.toString()),
    []
  );

  return (
    <FlatList
      data={data}
      keyExtractor={(item) => item}
      h={{ base: 'lg', sm: 'sm', lg: 'lg' }}
      ItemSeparatorComponent={Separator}
      showsVerticalScrollIndicator={false}
      renderItem={() => <LoadingRow />}
    />
  );
};
